
import Dot from '@/components/UntitledUI/Dot.vue'
import Icon from '@/components/UntitledUI/Icon.vue'
import Tippy from '@/components/common/Tippy.vue'

export default {
    name: 'MainTagsFilter',
    components: {
        Dot, Icon, Tippy
    },
    props: {
        tags: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            mounted: false
        }
    },
    methods: {
        changeMain (tag) {
            if (tag.locked) { return }
            this.$emit('change', tag)
        }
    }
}
